import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const Accordion = makeShortcode("Accordion");
const AccordionItem = makeShortcode("AccordionItem");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 STEP: Connect to Turbonomic`}</h2>
    <a href="https://www.ibm.com/docs/en/tarm/8.7.5?topic=clusters-installing-using-red-hat-openshift-operatorhub" target="_blank">🌏 Documentation for the Task:  Get the Route to open Turbonomic (Start at Step 9.)</a>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Networking/Routes`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/20_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Make sure you have selected the `}<inlineCode parentName="p">{`turbonomic`}</inlineCode>{` Project`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/21_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click on the link for the `}<inlineCode parentName="p">{`nginx`}</inlineCode>{` Route`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/22_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The Turbonomic Login will open`}</p>
      </li>
    </ol>
    <InlineNotification kind="warning" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Unsafe Connection`}</strong></p>
      <p>{`Depending on your Browser you might get a warning, saying that your connection is not secure.`}</p>
      <p>{`Tell the browser to ignore and continue.`}</p>
      <p>{`If you are using Chrome there might be no button to continue.`}</p>
      <p>{`Just type “thisisunsafe” (without the quotes). there is no visual feedback while you type but if you typed it correctly, Chrome will continue to Turbonomic.`}</p>
    </InlineNotification>
    <h2>{`🚀 STEP: Define Administrator Password`}</h2>
    <a href="https://www.ibm.com/docs/en/tarm/8.7.5?topic=clusters-installing-using-red-hat-openshift-operatorhub" target="_blank">🌏 Documentation for the Task:  Define Administrator Password (Start at Step 10.)</a>
    <p>{`In this section you will define the Administrator Password`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Enter the Password that you want to give the Turbonomic Administrator (twice)`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/23_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create Account`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Save And Continue`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/24_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will get a warning that there is no Turbonomic license loaded`}</p>
        <img parentName="li" {...{
          "src": "./../images/turbonomic/25_turbo.png",
          "alt": "turbo"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Continue to next Task to load a license`}</p>
      </li>
    </ol>
    <h2>{`🚀 STEP: Adding Temporary License`}</h2>
    <p>{`In this section you will load the Turbonomic License Key for the Training.`}</p>
    <InlineNotification kind="warning" mdxType="InlineNotification"> 
      <p><strong parentName="p">{`Turbonomic License Key `}</strong></p>
      <p>{`If you are not following this as part of an IBM training course, you will have to provide your own Turbonomic License key in the Turbonomic UI.`}</p>
    </InlineNotification>
    <p>{`There are two ways of loading the Turbonomic License Key:`}</p>
    <Accordion mdxType="Accordion">
      <AccordionItem title="🔎 If you are following an IBM Course" mdxType="AccordionItem">
        <h2>{`Activate Turbonomic`}</h2>
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Go to the following page:`}</p>
            <a href="https://ibm.biz/training-activation" target="_blank">🚀 Training Activation Portal</a>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Login with the Access Information `}<strong parentName="p">{`provided by the Course Trainer`}</strong>{`:`}</p>
            <ul parentName="li">
              <li parentName="ul">{`Course ID`}</li>
              <li parentName="ul">{`EMail Address`}</li>
              <li parentName="ul">{`Course Password`}</li>
            </ul>
            <img parentName="li" {...{
              "src": "./../images/instana/instana_install_02.png",
              "alt": "instana"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Activate Turbonomic`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/turbonomic/01_turbo_install.png",
              "alt": "instana"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Paste in the needed information`}</p>
            <ul parentName="li">
              <li parentName="ul">{`Turbonomic URL: copy from your browser`}</li>
              <li parentName="ul">{`Turbonomic Admin User: usually administrator`}</li>
              <li parentName="ul">{`Turbonomic Admin Password: The administrator password you have set in the previous step`}</li>
            </ul>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click `}<inlineCode parentName="p">{`Activate`}</inlineCode></p>
            <img parentName="li" {...{
              "src": "./../images/turbonomic/02_turbo_install.png",
              "alt": "instana"
            }}></img>
          </li>
          <li parentName="ol">
            <p parentName="li">{`If all is good, you should get a success message`}</p>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <Accordion mdxType="Accordion">
      <AccordionItem title="🔎 If you have Licenses available (self study)" mdxType="AccordionItem">
        <ol>
          <li parentName="ol">
            <p parentName="li">{`Open Turbonomic`}</p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on `}<inlineCode parentName="p">{`Settings`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Click on `}<inlineCode parentName="p">{`License`}</inlineCode></p>
          </li>
          <li parentName="ol">
            <p parentName="li">{`Import your license`}</p>
          </li>
        </ol>
      </AccordionItem>
    </Accordion>
    <p>{`Go back to Turbonomic and you should see a license for your Training instance`}</p>
    <img {...{
      "src": "./../images/turbonomic/33_turbo.png",
      "alt": "turbo"
    }}></img>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      